import * as $ from 'jquery';
$('.js-listing-form').submit(function (e) {
    $(this).fadeOut(1000);
    e.preventDefault();
    $.post("/contact", $(this).serialize(), function () {
        $('.js-listing-form-success').fadeIn();
    });
});
